import React from "react";
import "./style.css";
import { Button } from "@a365/dsys";
import { Trans, useTranslation } from "react-i18next";

const BannerPreFooter = ({ setOpenMod }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full banner-pre-footer-container">
      <div className="mx-auto w-full lg:max-w-[1366px] h-[340px] flex flex-col items-center justify-end pb-8">
        <div
          className="w-full max-w-[358px] lg:max-w-[998px] 
          rounded-3xl bg-white bg-opacity-85 py-4 lg:py-8 px-4
          lg:px-10 
          flex flex-col lg:flex-row items-center justify-between"
        >
          <img src="https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/logo.svg" />

          <h2 className="text-2xl lg:text-4xl font-semibild text-text-decorative-darker">
            <Trans
              i18nKey={"preFooterBanner.text"}
              components={{ strong: <strong></strong> }}
            />
          </h2>

          <Button
            onClick={() => setOpenMod(true)}
            variant="default"
            color="primary"
            icon="arrow"
            fullWidth={true}
            size="large"
            classes="flex justify-start mt-4 lg:mt-0 w-full lg:w-fit mx-4"
          >
            {t("preFooterBanner.btnLabel")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BannerPreFooter;
